// src/components/pages/admin/EpisodeCreatePage.js
import React from "react";
import EpisodeForm from "./organisms/EpisodeForm";
import { Container, Typography } from "@mui/material";

const EpisodeCreatePage = () => {
  return (
    <Container maxWidth="md">
      <Typography variant="h4" sx={{ my: 2 }}>
        Episode Management
      </Typography>
      <EpisodeForm />
    </Container>
  );
};

export default EpisodeCreatePage;
